import { useTranslation } from "react-i18next";
import type { MessageAttachmentDto } from "@multi-chat/shared";
import { cn } from "../../../lib/utils.js";
import { useInboxAttachmentUrl } from "../use-inbox-attachment-url.js";

export function MessageSticker({
  organizationId,
  attachment,
}: {
  organizationId: number;
  attachment: MessageAttachmentDto;
}): React.JSX.Element {
  const { t } = useTranslation();
  const { url, urlResolving, failed } = useInboxAttachmentUrl(organizationId, attachment);

  if (failed || (!url && !urlResolving)) {
    return (
      <p className="m-0 text-[0.8125rem] text-ink-subtle">{t("inbox.media.unavailable")}</p>
    );
  }

  if (urlResolving || !url) {
    return (
      <div
        className="my-0.5 size-24 animate-pulse rounded-md bg-transparent"
        role="status"
        aria-label={t("inbox.media.processing")}
      />
    );
  }

  return (
    <img
      src={url}
      alt={t("inbox.messageType.STICKER")}
      loading="lazy"
      className={cn(
        "my-0.5 block h-auto w-auto max-h-40 max-w-[10rem] bg-transparent object-contain",
      )}
    />
  );
}
